<!--<div class="app-share-wrap" id="share-wrap" [ngClass]="{'open':isShowPage,'close':!isShowPage}"-->
<!--     (touchstart)="onMouseDown($event)" (touchend)="onMouseUp($event)">-->
<div class="app-share-wrap" id="share-wrap" [ngClass]="{'open':isShowPage,'close':!isShowPage}">
  <div class="app-share-head clearfix">
    <div class="close-btn" (click)="closeSharePage()"></div>
  </div>

  <div class="app-cut-wrap" id="cut-wrap">
    <!--  金句-->
    <div class="app-share-section">
      <div class="app-share-gold">
        <p class="opacity0">{{goldenSentences}}</p>
        <p *ngIf="author" class="opacity0">{{author}}</p>
        <div class="app-share-shadow">
          <p [innerHtml] = "goldenSentences"></p>
          <p *ngIf="author" class="author">{{author}}</p>
        </div>
      </div>
    </div>

    <!--图片-->
    <div class="app-share-section share-pic">
      <img class="share-pic-{{learningPathMetaId}}" src="{{assetsRoute}}/picture/learningpath/share/{{learningPathMetaId}}.png" alt=""/>
    </div>

    <!--用户信息-->
    <div class="app-share-section share-info">
      <div class="app-share-info">
        <div class="app-share-user">
          <img class="user-photo" src="{{headImgUrl}}" alt=""/>
          <span class="user-name">{{userName}}</span>
        </div>
        <div class="app-share-desc">在<span class="desc-txt">{{courseName}}</span>中打败了<span class="font-orange"><font size="5">{{overcomeRatio}}</font>%</span>的管理者</div>
      </div>
    </div>

    <!--二维码区域-->
    <div class="app-share-section share-bottom">
      <img class="logo" src="{{assetsRoute}}/picture/share/darkLogo.png" alt="" />
      <img class="app-share-slogan" src="{{assetsRoute}}/picture/share/slogan.png" alt="" />
      <!--    <div class="app-share-slogan">-->
      <!--      <p>提升我的领导力，升级加薪步步为赢</p>-->
      <!--      <p>扫码前往英跃领导力线上学院</p>-->
      <!--    </div>-->
      <img class="qrcode" src="{{assetsRoute}}/picture/share/QRCode2.jpg" alt="" />
    </div>
  </div>


<!--分享按钮-->
  <div class="app-share-btn" (click)="clickSavePic()">保存图片</div>
</div>

<!--  图片区域-->
<div class="canvas-image-wrap">
  <img class="canvas-img" src="" alt="" />
  <!--提示区域-->
  <div class="app-share-tip-wrap">
    <p class="app-share-tip">长按图片保存分享</p>
  </div>
</div>

<div class="app-share-after-head" *ngIf="isShareAfter">
  <div class="close-btn" (click)="closeSharePage()"></div>
</div>







// WEBPACK FOOTER //
// ./src/app/app-share/app-share.component.html